module.exports = __webpack_public_path__ + "static/media/IMG-8.48600207.jpg";